import NavigationBreadcrumbs from 'src/navigation/components/NavigationBreadcrumbs'
import css from './alarmSituations.module.css'
import MainLayout from '@/shared/Layouts/MainLayout'
import { useMemo, useState } from 'react'
import CreateEntityButton from '@/shared/Buttons/CreateEntityButton'
import SearchInput from '@/shared/Inputs/SearchInput'
import AlarmSituationsDataTypeDropdown from './components/AlarmSituationsDataTypeDropdown'
import { useRecoilValue } from 'recoil'
import alarmSituationsAtom from './alarmSituations.atom.ts'
import AlarmSituationsTable from './components/AlarmSituationsTable'
import CreateAlarmSituationSidePage from './components/CreateAlarmSituationSidePage'
import ProtectedContent from '@/services/rights/ProtectedContent'
import useTitle from '@/shared/hooks/useTitle'

const AlarmSituationsPage = () => {
  useTitle('Сигнальные ситуации')
  const [search, setSearch] = useState('')
  const [filterLevel, setFilterLevel] = useState(null)
  const [createSidePageOpen, setCreateSidePageOpen] = useState(false)
  const alarmSituations = useRecoilValue(alarmSituationsAtom).items

  const items = useMemo(() => {
    let resultItems = alarmSituations

    if (search) {
      const lowerSearch = search.toLowerCase()
      resultItems = resultItems.filter((p) => p.name.toLowerCase().includes(lowerSearch))
    }

    if (filterLevel) {
      resultItems = resultItems.filter((p) => p.level === filterLevel)
    }

    return resultItems
  }, [alarmSituations, search, filterLevel])

  return (
    <MainLayout>
      <div className={css.wrapper}>
        <div className="flex-lines gap16 height100">
          <NavigationBreadcrumbs />
          <div className="flex-lines gap4">
            <h2 className="text-heading-3">Сигнальные ситуации</h2>
          </div>
          <div className={css.mainCard}>
            <div className="flex-lines gap8">
              <ProtectedContent
                requiredRight="alarmSituations:create"
                fallBack={
                  <span className="text-nm text-secondary">
                    Для добавления нового тригера обратитесь к администратору системы
                  </span>
                }
              >
                <CreateEntityButton onClick={() => setCreateSidePageOpen(true)} text="Создать триггер" />
              </ProtectedContent>
            </div>
            <div className={css.wrapperSearch}>
              <div className={css.searchInput}>
                <SearchInput value={search} name="search" onChange={setSearch} placeHolder="Поиск по триггерам" />
              </div>
              <AlarmSituationsDataTypeDropdown
                name="dataType"
                value={filterLevel}
                onChange={setFilterLevel}
                title="Тип"
                wrapperStyle={{ height: '32px', width: '200px' }}
              />
            </div>
            <AlarmSituationsTable items={items} />
          </div>
        </div>
      </div>
      <CreateAlarmSituationSidePage open={createSidePageOpen} onClose={() => setCreateSidePageOpen(false)} />
    </MainLayout>
  )
}

export default AlarmSituationsPage
